// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.vti {
  min-height: 38px;
  padding: 5px 12px;
  border: 1px solid #ced4da;
  border-radius: 4px;
  font-size: 14px;
  line-height: 1.6;
  background: #fff;
  cursor: text;
  overflow: hidden;
  white-space: nowrap;
  display: flex;
  align-items: center;
  flex-wrap: nowrap;
  gap: 1px;
}

.vti:focus {
  outline: none;
  border-color: #80bdff;
  box-shadow: 0 0 0 0.2rem rgba(0, 123, 255, 0.25);
}

.vti--disabled {
  background: #e9ecef;
  cursor: default;
  color: #495057;
}

.vti:empty::before {
  content: attr(data-placeholder);
  color: #6c757d;
  pointer-events: none;
}

.vti__chip {
  display: inline-flex;
  align-items: center;
  gap: 5px;
  min-height: 24px;
  border-radius: 999px;
  padding: 1px 4px 1px 9px;
  font-size: 12px;
  font-weight: 700;
  line-height: 1.4;
  margin: 1px 2px;
  cursor: default;
  user-select: none;
  vertical-align: middle;
  font-family: var(--font-body, inherit);
  letter-spacing: 0;
  flex-shrink: 0;
}

.vti__chipRemove {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 17px;
  height: 17px;
  border-radius: 50%;
  color: currentColor;
  font-size: 15px;
  font-weight: 500;
  line-height: 1;
  cursor: pointer;
  opacity: 0.68;
}

.vti__chipRemove:hover {
  background: rgba(15, 23, 42, 0.1);
  opacity: 1;
}

.vti__chip--child {
  background: #dbeafe;
  color: #1e40af;
  border: 1px solid #93c5fd;
}
.vti__chip--recipient {
  background: #dcfce7;
  color: #166534;
  border: 1px solid #86efac;
}
.vti__chip--school {
  background: #ede9fe;
  color: #6d28d9;
  border: 1px solid #c4b5fd;
}
.vti__chip--sender {
  background: #fef3c7;
  color: #92400e;
  border: 1px solid #fcd34d;
}
.vti__chip--other {
  background: #f1f5f9;
  color: #475569;
  border: 1px solid #cbd5e1;
}
`, "",{"version":3,"sources":["webpack://./src/components/VariableTextInput/VariableTextInput.css"],"names":[],"mappings":"AAAA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,YAAY;EACZ,gBAAgB;EAChB,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,iBAAiB;EACjB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,gDAAgD;AAClD;;AAEA;EACE,mBAAmB;EACnB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,+BAA+B;EAC/B,cAAc;EACd,oBAAoB;AACtB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;EAChB,oBAAoB;EACpB,wBAAwB;EACxB,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,eAAe;EACf,eAAe;EACf,iBAAiB;EACjB,sBAAsB;EACtB,sCAAsC;EACtC,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,aAAa;AACf;;AAEA;EACE,iCAAiC;EACjC,UAAU;AACZ;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,yBAAyB;AAC3B;AACA;EACE,mBAAmB;EACnB,cAAc;EACd,yBAAyB;AAC3B;AACA;EACE,mBAAmB;EACnB,cAAc;EACd,yBAAyB;AAC3B;AACA;EACE,mBAAmB;EACnB,cAAc;EACd,yBAAyB;AAC3B;AACA;EACE,mBAAmB;EACnB,cAAc;EACd,yBAAyB;AAC3B","sourcesContent":[".vti {\n  min-height: 38px;\n  padding: 5px 12px;\n  border: 1px solid #ced4da;\n  border-radius: 4px;\n  font-size: 14px;\n  line-height: 1.6;\n  background: #fff;\n  cursor: text;\n  overflow: hidden;\n  white-space: nowrap;\n  display: flex;\n  align-items: center;\n  flex-wrap: nowrap;\n  gap: 1px;\n}\n\n.vti:focus {\n  outline: none;\n  border-color: #80bdff;\n  box-shadow: 0 0 0 0.2rem rgba(0, 123, 255, 0.25);\n}\n\n.vti--disabled {\n  background: #e9ecef;\n  cursor: default;\n  color: #495057;\n}\n\n.vti:empty::before {\n  content: attr(data-placeholder);\n  color: #6c757d;\n  pointer-events: none;\n}\n\n.vti__chip {\n  display: inline-flex;\n  align-items: center;\n  gap: 5px;\n  min-height: 24px;\n  border-radius: 999px;\n  padding: 1px 4px 1px 9px;\n  font-size: 12px;\n  font-weight: 700;\n  line-height: 1.4;\n  margin: 1px 2px;\n  cursor: default;\n  user-select: none;\n  vertical-align: middle;\n  font-family: var(--font-body, inherit);\n  letter-spacing: 0;\n  flex-shrink: 0;\n}\n\n.vti__chipRemove {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 17px;\n  height: 17px;\n  border-radius: 50%;\n  color: currentColor;\n  font-size: 15px;\n  font-weight: 500;\n  line-height: 1;\n  cursor: pointer;\n  opacity: 0.68;\n}\n\n.vti__chipRemove:hover {\n  background: rgba(15, 23, 42, 0.1);\n  opacity: 1;\n}\n\n.vti__chip--child {\n  background: #dbeafe;\n  color: #1e40af;\n  border: 1px solid #93c5fd;\n}\n.vti__chip--recipient {\n  background: #dcfce7;\n  color: #166534;\n  border: 1px solid #86efac;\n}\n.vti__chip--school {\n  background: #ede9fe;\n  color: #6d28d9;\n  border: 1px solid #c4b5fd;\n}\n.vti__chip--sender {\n  background: #fef3c7;\n  color: #92400e;\n  border: 1px solid #fcd34d;\n}\n.vti__chip--other {\n  background: #f1f5f9;\n  color: #475569;\n  border: 1px solid #cbd5e1;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
